export const IMAGES = {
  hero: "/images/nelle-facepaint.jpg",
  portrait1: "/images/nelle-daisies.jpg",
  beautyJersey: "/images/nelle-jersey.jpg",
  beautyMosaic: "/images/nelle-mosaic.jpg",
  beautyAfterHours: "/images/nelle-purple.jpg",
};

export const NAV_LINKS = [
  { label: "The Hub", href: "#hub" },
  { label: "Brands", href: "#brands" },
  { label: "Nelle", href: "#nelle" },
  { label: "Music", href: "#music" },
  { label: "Ideas", href: "#ideas" },
];

export const MARQUEE_ITEMS = [
  "ONE HUB",
  "MANY WORLDS",
  "BEAUTY + STYLE",
  "MUSIC",
  "IDEAS",
  "MEDIA",
  "PROJECTS",
  "BUSINESSES",
  "LIFE",
  "THE HUB OF IT ALL",
];

export const WORLDS = [
  {
    id: "beauty-style",
    name: "Beauty + Style",
    color: "#DB2777",
    status: "archiving looks",
    blurb: "Personal beauty, makeup, hair, fashion and visual expression. Not a counter — a mirror with better lighting.",
    items: ["Editorial lookbooks & moodboards", "Visual diaries in full color", "Experiments that may never repeat"],
    href: "#beauty",
  },
  {
    id: "music",
    name: "Music",
    color: "#F43F5E",
    status: "in the studio",
    blurb: "Original songs, lyrics, releases and the beautiful mess of the creative process behind them.",
    items: ["A growing digital record archive", "Lyrics, demos & voice notes", "Visual + behind-the-scenes material"],
    href: "#music",
  },
  {
    id: "ideas",
    name: "Ideas",
    color: "#2563EB",
    status: "always open",
    blurb: "Thoughts, observations, writing, lessons and concepts currently being explored — filed loosely, on purpose.",
    items: ["Essays & cultural storytelling", "Notes on building & becoming", "Interesting discoveries, annotated"],
    href: "#ideas",
  },
  {
    id: "media",
    name: "Media",
    color: "#7E22CE",
    status: "in conversation",
    blurb: "Podcasts, interviews, storytelling, video and future media projects. Conversations worth keeping.",
    items: ["Podcasts & conversations", "Interviews & field notes", "Video projects with a point of view"],
    href: "#brands",
  },
  {
    id: "projects",
    name: "Projects",
    color: "#F97316",
    status: "experiments",
    blurb: "Creative experiments, collaborations, cultural projects, events and things being built in public.",
    items: ["Experiments & collaborations", "Cultural projects & gatherings", "Things that start as 'what if'"],
    href: null,
  },
  {
    id: "businesses",
    name: "Businesses",
    color: "#10B981",
    status: "the gateway",
    blurb: "The gateway to independent brands and companies growing out of the Eclectically Nelle ecosystem.",
    items: ["Prismatic Essence — luxury beauty", "Independent brands, each its own world", "Grown here. Launched from here."],
    href: "#brands",
  },
  {
    id: "life",
    name: "Life",
    color: "#06B6D4",
    status: "being lived",
    blurb: "Travel, food, thrifting, everyday creativity and the gloriously uncurated human part of all of this.",
    items: ["Travel & food diaries", "Thrifting as research", "Everyday creativity, unfiltered"],
    href: null,
  },
];

export const BRANDS = [
  {
    id: "prismatic",
    name: "Prismatic Essence",
    tag: "Luxury Beauty Experience",
    status: "Now open",
    est: "EST. 2026",
    desc: "A luxury beauty experience — hair, skin, makeup, maintenance and education under one roof. Its own world, its own name. Born here — not merged into here.",
    headerClass: "bg-gradient-to-br from-[#EADEC9] via-[#D2C0A5] to-[#5A6B4C]",
    chipClass: "bg-amber-100 text-amber-800",
    accent: "#2C3A28",
  },
];

export const SONGS = [
  {
    id: "bloom-language",
    title: "Bloom Language",
    year: "2026",
    mood: "art pop",
    length: "3:42",
    gradient: "from-rose-500 via-fuchsia-500 to-indigo-500",
    note: "written after the garden finally did something",
    lyrics: [
      "I planted every maybe in a row,",
      "watered the doubt and watched it grow —",
      "turns out the dark was just a door,",
      "and I bloom in a language you ain't heard before.",
    ],
  },
  {
    id: "half-light",
    title: "Half-Light",
    year: "2026",
    mood: "midnight soul",
    length: "4:07",
    gradient: "from-indigo-600 via-blue-500 to-cyan-400",
    note: "for the drive home you take the long way",
    lyrics: [
      "Meet me in the half-light,",
      "where the day forgives the night,",
      "every version I ever was",
      "is holding up a porch light.",
    ],
  },
  {
    id: "satellite-heart",
    title: "Satellite Heart",
    year: "2025",
    mood: "cosmic r&b",
    length: "3:18",
    gradient: "from-violet-600 via-purple-500 to-pink-500",
    note: "orbiting is still a form of loyalty",
    lyrics: [
      "I've got a satellite heart,",
      "circling everything you are,",
      "signal got lost in the stars —",
      "but I never drifted far.",
    ],
  },
  {
    id: "proof-of-grace",
    title: "Proof of Grace",
    year: "2025",
    mood: "gospel-tinged ballad",
    length: "4:51",
    gradient: "from-amber-400 via-orange-500 to-rose-600",
    note: "the one the choir room asked about",
    lyrics: [
      "I didn't climb here on my own,",
      "every step was on a stone",
      "Somebody laid before my road —",
      "I'm the proof of grace, I know.",
    ],
  },
];

export const ARTICLES = [
  {
    id: "red-lipstick",
    category: "Beauty History",
    color: "#DB2777",
    title: "A Short, Opinionated History of Red Lipstick",
    dek: "From Mesopotamia to your grandmother's purse — power has always come in a tube.",
    issue: "Nº 007",
    read: "6 min",
  },
  {
    id: "boring-tuesday",
    category: "Creativity",
    color: "#7E22CE",
    title: "Why Every Creative Needs a Boring Tuesday",
    dek: "In defense of the unremarkable afternoon where the actual ideas show up.",
    issue: "Nº 007",
    read: "4 min",
  },
  {
    id: "build-before-ready",
    category: "Entrepreneurship",
    color: "#10B981",
    title: "Notes on Building Before You're Ready",
    dek: "Readiness is a rumor. Start with what you have, where you are, in full color.",
    issue: "Nº 006",
    read: "8 min",
  },
  {
    id: "color-theory",
    category: "Culture",
    color: "#2563EB",
    title: "Color Theory for People Who Feel Things",
    dek: "Cobalt is a mood. Tangerine is a decision. A field guide to wearing your insides.",
    issue: "Nº 006",
    read: "5 min",
  },
  {
    id: "thrifting-research",
    category: "Life",
    color: "#06B6D4",
    title: "Thrifting as Research: A Methodology",
    dek: "Every secondhand rack is an archive. Here's how to read one properly.",
    issue: "Nº 005",
    read: "7 min",
  },
  {
    id: "grandmothers-kitchen",
    category: "Food",
    color: "#F97316",
    title: "What My Grandmother's Kitchen Taught Me About Branding",
    dek: "Season to taste. Never rush the pot. Serve everything like you mean it.",
    issue: "Nº 005",
    read: "5 min",
  },
];

export const SWATCHES = [
  { name: "ELECTRIC BLUE", hex: "#2563EB" },
  { name: "COBALT", hex: "#1E40AF" },
  { name: "RICH PURPLE", hex: "#7E22CE" },
  { name: "VIVID PINK", hex: "#EC4899" },
  { name: "WARM ORANGE", hex: "#F97316" },
  { name: "GOLDEN YELLOW", hex: "#EAB308" },
  { name: "FRESH GREEN", hex: "#10B981" },
  { name: "TURQUOISE", hex: "#06B6D4" },
];

export const SOCIALS = [
  { id: "instagram", label: "Instagram" },
  { id: "tiktok", label: "TikTok" },
  { id: "youtube", label: "YouTube" },
  { id: "music-platforms", label: "Music Platforms" },
  { id: "email", label: "Email" },
];
